module.exports = require("@bechtel/client-assets/dist/images/search-results.svg");